import { isTieredVariant } from '@lub0v/santa-utils';
import { useAppSelector } from '@src/state/hooks';
import { premiumFeatureTier } from '@src/pages/PremiumPage/featureTier';
import { usePremiumOffer } from '@src/pages/PremiumPage/PremiumOfferProvider';
import { useNavigate } from 'react-router-dom';
import { closeDialog } from '@src/components/Dialog/Dialog';
import { premiumReturnSource } from '@src/utils/premiumReturn';
import { mainSiteUrl } from '@src/routing/boxDomainNavigation';
import { trackPremium } from '@src/utils/premiumAnalytics';

/** Final purchase actions always continue on the main site. */
export function useStartPremiumPurchase() {
  const navigate = useNavigate();
  const user = useAppSelector(state => state.session.user);
  const offer = usePremiumOffer();
  const wizardOffer = usePremiumOffer('themes');
  const masterOffer = usePremiumOffer('draw');
  const magisterOffer = usePremiumOffer('address');
  return (placement: string, feature = 'all', context?: string, selectedTier?: string) => {
    const alreadyAtCheckout = window.location.pathname.replace(/\/+$/, '') === '/premium/buy';
    const tier = selectedTier ?? (isTieredVariant(offer.variant) ? premiumFeatureTier(feature) : undefined);
    const clickedOffer = tier === 'tier_1' ? wizardOffer : tier === 'tier_2' ? masterOffer : tier === 'tier_3' ? magisterOffer : offer;
    const access = user?.premium?.offers.find(item => item.tier === tier);
    const purchaseType = access?.status === 'upgrade' ? 'upgrade' : access?.status === 'purchase' ? 'initial_purchase' : undefined;
    trackPremium('premium_unlock_clicked_v2', { placement, feature, context, purchaseType, currentTier: user?.premium?.access.tier ?? undefined, targetTier: tier, action: alreadyAtCheckout ? 'resume_checkout' : 'open_buy_page' }, clickedOffer);
    if (alreadyAtCheckout) {
      closeDialog();
      return;
    }
    const params = new URLSearchParams({ source: placement, feature, ...(context ? { context } : {}) });
    if (tier) params.set('tier', tier);
    const returnTo = premiumReturnSource();
    if (returnTo) params.set('returnTo', returnTo);
    const search = new URLSearchParams(window.location.search);
    const automaticPayment = search.get('automaticPayment');
    if (automaticPayment === 'true' || automaticPayment === 'false') {
      params.set('automaticPayment', automaticPayment);
    }
    if (automaticPayment !== 'false' && search.has('price')) {
      params.set('automaticPayment', 'true');
      params.set('price', search.get('price') || '');
    }
    const target = new URL(mainSiteUrl(`/premium/buy?${params}`), window.location.origin);
    closeDialog();
    if (target.origin === window.location.origin) {
      navigate(target.pathname + target.search + target.hash);
    } else {
      window.location.assign(target.href);
    }
  };
}
